"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var countController_1 = require("./countController");
var RawSampleController = (function () {
    function RawSampleController(table, analysisId, mmxl) {
        this._table = table;
        this._countController = new countController_1.CountController(analysisId, mmxl);
    }
    RawSampleController.prototype.updateRawSample = function (context, doUpdate) {
        var _this = this;
        if (!doUpdate || !context.prefilter || !context.audience) {
            return Promise.resolve();
        }
        return this.setSingleRawSamples(context).then(function () {
            _this.setTotalSamples(context).then(function () {
                var filter = [context.prefilter, context.audience];
                var items = [{ type: "A", key: "FG" }];
                var countRequest = _this._countController.sendRequest(items, ["rawSample"], filter, context.plan.dates);
                return countRequest.then(function (countResponse) {
                    if (countResponse && countResponse.length > 0 && countResponse[1]) {
                        var rawSample = _.get(countResponse[0][1], "rawSample");
                        _this._table.limitValue = rawSample;
                    }
                });
            });
        });
    };
    RawSampleController.prototype.setSingleRawSamples = function (context) {
        var mediaAndPlacements = RawSampleController.getMediaAndPlacementsFromContext(context);
        var media = mediaAndPlacements.media;
        var placements = mediaAndPlacements.placements;
        var countRequest = this._countController.sendRequest([], ["rawSample"], media);
        return countRequest.then(function (countResponse) {
            countResponse.forEach(function (responseItem, index) {
                _.set(placements[index], "rawSample", responseItem.rawSample);
            });
        });
    };
    RawSampleController.prototype.setTotalSamples = function (context) {
        var _this = this;
        var media = RawSampleController.getMediaAndPlacementsFromContext(context).media;
        var orItems = countController_1.CountController.createOR(media);
        var countRequest = this._countController.sendRequest([], ["rawSample"], orItems, context.plan.dates);
        return countRequest.then(function (countResponse) {
            if (countResponse.length > 0) {
                _.set(_this._table.totalRow, "rawSample", countResponse[0].rawSample);
            }
        });
    };
    RawSampleController.getMediaAndPlacementsFromContext = function (context) {
        var media = [];
        var placements = [];
        context.plan.mediumGroups.forEach(function (mediumGroup) {
            mediumGroup.mediumGroup.forEach(function (placement) {
                media.push(placement.medium);
                placements.push(placement);
            });
        });
        return { placements: placements, media: media };
    };
    RawSampleController.prototype.retrieveSingleRawSamplesFromPlan = function (plan, dates) {
        var countRequest = this._countController.sendRequest([], ["rawSample"], plan.media, dates);
        return countRequest.then(function (countResponse) {
            if (countResponse[0]) {
                return countResponse[0].rawSample;
            }
        });
    };
    return RawSampleController;
}());
exports.RawSampleController = RawSampleController;
//# sourceMappingURL=rawSampleController.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/rawSampleController.js
// module id = 67
// module chunks = 0